
import { defineAsyncComponent, defineComponent } from "vue";
const Slider = defineAsyncComponent(
  () => import("@/components/elements/forms/Slider.vue")
);

export default defineComponent({
  components: { Slider },
  props: {
    title: {
      type: String,
      required: true,
    },
    selections: {
      type: Object,
      required: true,
    },
    currentSelection: {
      type: String,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value"],
  setup(props) {
    return {};
  },
});
